import React from 'react';
import { FontIcon } from 'react-toolbox';
import cx from 'classnames';
import S from 'calendar.scss';

const CalendarLegend = () =>
  <div className={S.legend}>
    <div className={cx(S.legendItem, S.legendItemFlex)}>
      <FontIcon className={S.legendIcon} value="priority_high" />
      Priority Customer
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.fd_install)} />
      FD Install/Hold
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.fd_repair)} />
      FD Repair/Hold
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.assessment)} />
      Assessment
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.stack_cali_bamboo)} />
      Stack Cali Bamboo
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.stk_installation)} />
      STK Installation
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.sos_installation)} />
      SOS Installation
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.inspection)} />
      WO Inspection
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.crew_and_repair)} />
      Crew Inspection/Repair/Workorder Hold
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.delivery)} />
      Delivery/Hold
    </div>
    <div className={S.legendItem}>
      <span className={cx(S.legendSwatch, S.deliver_stack_cali_bamboo)} />
      D/S Cali Bamboo
    </div>
  </div>;

export default CalendarLegend;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/calendarLegend.jsx